module.exports = __webpack_public_path__ + "static/img/HP10c.a80f56c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assignments/java/images/HP10c.jpg
// module id = 3m7j
// module chunks = 1